import { NgClass, NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ThemeService } from '@service/theme.service';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
  imports: [NgClass, NgStyle],
  standalone: true,
})
export class SkeletonLoaderComponent {
  appearance = input<'circle' | 'line' | 'custom-content' | ''>('line');
  animation = input<'progress' | 'pulse' | 'false' | false>('progress');
  loadingText = input<string>('Loading...');
  count = input<number>(1);
  ariaLabel = input<string>('loading');
  styles = input<{ [k: string]: any } | null>(null);
  containerClasses = input<string>('');
  robotClasses = input<string>('robot_skeletonLoader');

  readonly items = computed(() => {
    // count = 1 when custom-content is used
    let count = this.appearance() === 'custom-content' ? 1 : this.count() || 1;
    return [...Array(count)].map((_, index) => index);
  });

  constructor(protected themeService: ThemeService) {}
}
